import { CommonModule } from '@angular/common';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { ComboService } from '../../Model/Combo/combo.service';
import { ConfirmationComponent } from '../../Component/Confirmation/confirmation/confirmation.component';
import { SessionService } from '../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { MultipleLocationGeoMappingServiceService } from '../../Model/LocationMaster/MultipleLocationGeoMapping/multiple-location-geo-mapping-service.service';
import { Subject } from 'rxjs';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
//import { Router } from '@angular/router';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';
import { CommonService } from '../../Model/Common/common.service';
import { DownloadSampleService } from '../../Model/DownloadSample/download-sample.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-multiple-location-geo-mapping',
  standalone: true,
  imports: [NgbModule, FormsModule, ReactiveFormsModule, NgSelectModule, CommonModule, DataTablesModule],
  templateUrl: './multiple-location-geo-mapping.component.html',
  styleUrl: './multiple-location-geo-mapping.component.scss'
})
export class MultipleLocationGeoMappingComponent {
  isDisabled: boolean = false;
  BranchMaster: any[] = [];
  ClientLoad: any[] = [];
  SiteLoad: any[] = [];
  BranchId: any = null;
  BranchName: string = '';
  ClientId: any = null;
  ClientName: string = '';
  SiteId: any = null;
  SiteName: string = '';
  SiteCode: string = '';
  public User: any = null;
  MultipleLocationMapLoad: any[] = [];
  SiteGateName: string = '';
  Latitude: any = '';
  Longitude: any = '';
  IsMocked: number = 0;
  Accuracy: any = '';
  Altitude: any = '';
  Heading: any = '';
  Radius: any = '';
  AltitudeRadius: any = '';
  IsAltitudeApplicable: any = false;
  EditMode: boolean = false;
  dtTrigger: Subject<any> = new Subject<any>();
  dtInstance!: DataTableDirective;
  LocationGeoMappingID: number = 0;
  MultiGeoData: any[] = []
  MultiGeoRecord: any[] = [];
  dtoptions: DataTables.Settings = {};
  constructor(private multipleGeoMapService: MultipleLocationGeoMappingServiceService,
    private sessionService: SessionService,
    private comboload: ComboService,
    private toast: ToastService,
    private modalService: NgbModal,
    // private dtElement: ElementRef,
    // private router: Router,
    protected common: CommonService,
    private tooltip: TooltipService,
    private download: DownloadSampleService
  ) {
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }
  // @ViewChild(DataTableDirective, { static: false }) dtLocation!: DataTableDirective;
  ngOnInit(): void {
    this.ComboLoad('Branch');
  }
  onSelectChange(type: string) {
    if (type === 'Branch') {
      const selected = this.BranchMaster.find(duty => duty.BranchMasterID === this.BranchId);
      this.BranchName = selected ? selected.BranchName : null;
      this.ClientId = null;
      this.ClientName = ''
      this.SiteCode = ''
      this.SiteName = ''
      this.SiteId = null
      this.MultipleLocationMapLoad = []
    } else if (type == 'Client') {
      const selected = this.ClientLoad.find(site => site.ClientGroupMasterID === this.ClientId);
      this.ClientName = selected ? selected.ClientGroupName : null;
      this.SiteCode = ''
      this.SiteName = ''
      this.SiteId = null
      this.MultipleLocationMapLoad = []
    } else if (type === 'Site') {
      const selected = this.SiteLoad.find(duty => duty.SiteMasterID === this.SiteId);
      this.SiteName = selected ? selected.SiteName : null;
      this.SiteCode = selected ? selected.SiteCode : null;
      this.MultipleLocationMapLoad = []
      this.getData();
    }
  }
  ComboLoad(Combotype: String, Combotype2: string = '', index = 0) {
    this.comboload.ComboLoad({
      'Combotype': Combotype,
      'BranchId': (Combotype == 'Client' || Combotype == 'Site' || Combotype == 'Designation' || Combotype == 'Duty') ? this.BranchId : 0,
      'ClientId': (Combotype == 'Site' || Combotype == 'Designation' || Combotype == 'Duty') ? this.ClientId : 0,
      'SiteId': (Combotype == 'Designation' || Combotype == 'Duty') ? this.SiteId : 0,
      // 'EmpType': 'front'
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Branch') {
          this.BranchMaster = response.ComboLoad;
        } else if (Combotype == 'Client') {
          this.ClientLoad = response.ComboLoad;
        } else if (Combotype == 'Site') {
          this.SiteLoad = response.ComboLoad;
        }
      },
      complete: () => {
      },
      error: (error) => {
      },
    });
  }
  async save() {
    await this.common.getPageRights();
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      // centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Are you Sure want to save?'
    modalRef.result.then((result: any) => {
      if (this.common.PageRight.IsEdit) {
        if (result) {
          this.InsertUpdate();
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    }).catch(() => { });
  }
  getData() {
    const data = {
      SelectType: 1,
      SiteId: this.SiteId
    };
    this.isDisabled = true;
    this.multipleGeoMapService.MultipleLocationGeoMapLoad(data).subscribe(
      data => {
        this.MultipleLocationMapLoad = data;
        this.isDisabled = false;
      },
      error => {
        console.error('Error:', error);
        this.isDisabled = false;
      }
    );
  }

  InsertUpdate() {
    if (!this.BranchName || this.BranchName == '' || this.BranchId == 0) {
      this.toast.show({ message: 'Please select Branch !', type: toastTypeEnum.warning });
      return;
    }
    if (!this.ClientName || this.ClientName == '' || this.ClientId == 0) {
      this.toast.show({ message: 'Please select Client !', type: toastTypeEnum.warning });
      return;
    }
    if (!this.SiteName || this.SiteName == '' || this.SiteId == 0) {
      this.toast.show({ message: 'Please select Site !', type: toastTypeEnum.warning });
      return;
    }
    if (this.SiteGateName == '') {
      this.toast.show({ message: 'Please Fill Site Gate Name!', type: toastTypeEnum.warning });
      return;
    }
    this.User = this.sessionService.GetUserDetails();
    const multigeolocationData = {
      SelectType: this.EditMode ? 'Update' : 'Insert',
      ESS_SiteGateGeoMappingID: this.LocationGeoMappingID,
      SiteId: this.SiteId,
      SiteGateName: this.SiteGateName,
      Latitude: this.Latitude,
      Longitude: this.Longitude,
      Accuracy: this.Accuracy,
      Altitude: this.Altitude,
      IsAltitudeApplicable: this.IsAltitudeApplicable,
      AltitudeRadius: this.AltitudeRadius,
      Heading: this.Heading,
      Radius: this.Radius,
      IsMocked: this.IsMocked,
      By: this.User.UserId
    };
    this.multipleGeoMapService.MultipleLocationGeoMapInsertUpate(multigeolocationData).subscribe(
      data => {
        if (data.Error_Code == '01') {
          this.toast.show({ message: 'Multiple Location Geo Saved Successfully', type: toastTypeEnum.success });
          this.clearInputFields();
          this.EditMode = false;
          this.getData();
        }
        else {
          this.toast.show({ message: data.Error_Message, type: toastTypeEnum.danger });
        }
      },
      error => {
        console.error('Error:', error);
        this.EditMode = false;
      });
  }

  onEditClick(element: any): void {
    this.EditMode = true;
    this.LocationGeoMappingID = element.ESS_SiteGateGeoMappingID;
    this.SiteCode = element.SiteCode,
      this.SiteId = element.SiteId,
      this.SiteName = element.SiteName,
      this.SiteGateName = element.SiteGateName,
      this.Latitude = element.Latitude,
      this.Longitude = element.Longitude,
      this.Accuracy = element.Accuracy,
      this.Altitude = element.Altitude,
      this.IsAltitudeApplicable = element.IsAltitudeApplicable,
      this.AltitudeRadius = element.AltitudeRadius,
      this.Heading = element.Heading,
      this.Radius = element.Radius,
      this.IsMocked = element.IsMocked
  }
  clearInputFields() {
    this.EditMode = false;
    this.Latitude = '';
    this.SiteGateName = '';
    this.Longitude = '';
    this.Accuracy = '';
    this.Altitude = '';
    this.IsAltitudeApplicable = false;
    this.AltitudeRadius = '';
    this.Heading = '';
    this.Radius = '';
    this.IsMocked = 0;
  }
  reset() {
    this.EditMode = false;
    window.location.reload();
  }

  ValidateInput(event: KeyboardEvent, type: string) {
    const charCode = event.which ? event.which : event.keyCode;
    const input = (event.target as HTMLInputElement).value;
    const dotCount = input.split('.').length - 1;
    const minusCount = (input.match(/-/g) || []).length;
    const cursorPosition = (event.target as HTMLInputElement).selectionStart;

    if (type === 'Latitude') {
      if (
        (charCode !== 46 && charCode !== 45 && (charCode < 48 || charCode > 57)) ||
        (dotCount > 0 && charCode === 46 && (cursorPosition !== null && cursorPosition <= input.indexOf('.') + 1)) ||
        (charCode === 45 && (cursorPosition !== null && cursorPosition !== 0)) ||
        (minusCount > 0 && charCode === 45)
      ) {
        event.preventDefault();
        return;
      }
      if (input.length >= 25) {
        event.preventDefault();
        return;
      }
    }
    else if (type === 'NumandDec') {
      if (
        (charCode !== 46 && charCode !== 45 && (charCode < 48 || charCode > 57)) ||
        (dotCount > 0 && charCode === 46 && (cursorPosition !== null && cursorPosition <= input.indexOf('.') + 1)) ||
        (charCode === 45 && (cursorPosition !== null && cursorPosition !== 0)) ||
        (minusCount > 0 && charCode === 45)
      ) {
        event.preventDefault();
        return;
      }
    }
    else if (type === 'radius') {
      if (
        charCode !== 46 &&
        charCode > 31 &&
        (charCode < 48 || charCode > 57) ||
        (dotCount > 0 && charCode === 46)
      ) {
        event.preventDefault();
      }
    }
  }
  onPaste(event: ClipboardEvent): void {
    event.preventDefault();
  }
  exportToExcel() {
    this.isDisabled = true
    const data = {
      SelectType: 'SiteGateGeoMappingMasterExcel',
      Year: ''
    }
    this.download.ESS_ExcelDump(data).subscribe(
      data => {
        this.MultiGeoData = data;
        if (this.MultiGeoData.length > 0) {
          this.download.exportToExcel(this.MultiGeoData, "MultipleGeoMapping_data");
          this.isDisabled = false
        }
        else {
          this.toast.show({ message: 'No Data Found!', type: toastTypeEnum.warning });
          this.isDisabled = false
        }
      });
  }

  handleFileInput(event: any): void {
    this.MultiGeoRecord.length = 0;
    const files: FileList = event.target.files;
    if (files && files.length > 0) {
      const file: File = files[0];
      const fileType: string | undefined = file.name.split('.').pop();
      if (fileType !== 'xlsx' && fileType !== 'xls') {
        this.toast.show({ message: 'Please select an Excel file only.', type: toastTypeEnum.danger });
        return;
      }
      this.processExcelFile(file);
      event.target.value = '';
    }
  }
  processExcelFile(file: File): void {
    const reader = new FileReader();
    reader.onload = (event) => {
      if (event && event.target && event.target.result) {
        const binaryString = event.target.result as string;
        const workbook = XLSX.read(binaryString, { type: 'binary' });
        const sheetName = 'Sheet1';
        if (!workbook.SheetNames.includes(sheetName)) {
          const errorMessage = 'Sheet1 not found in the uploaded file.';
          this.toast.show({ message: errorMessage, type: toastTypeEnum.danger });
          return;
        }
        const worksheet = workbook.Sheets[sheetName];
        const excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }) as any[][];
        const headerRow = excelData[0];
        const headers = headerRow.map((header: string) => header.trim());
        const dataRows = excelData.slice(1);

        const uniqueLocationIds: Set<number> = new Set();
        const LocationNames: Set<string> = new Set();
        this.MultiGeoRecord = [];

        for (let rowIndex = 0; rowIndex < dataRows.length; rowIndex++) {
          const row = dataRows[rowIndex];
          const rowData: any = {};

          row.forEach((cellData, index) => {
            rowData[headers[index]] = cellData;
          });

          const id = rowData['ESS_SiteGateGeoMappingID'];
          let siteCode = rowData['SiteCode'].toString();
          let siteName = rowData['SiteName'].toString();
          let sitegatename = rowData['SiteGateName'].toString();
          let isaltitudeapplicable = rowData['IsAltitudeApplicable'].toString();
          let altituderadius = rowData['AltitudeRadius'].toString();
          siteName = siteName ? siteName.trim() : '';
          sitegatename = sitegatename ? sitegatename.trim() : '';

          if (id !== 0 && id !== '' && id !== undefined && uniqueLocationIds.has(id)) {
            this.toast.show({ message: `Duplicate ESS_SiteGateGeoMapping ID '${id}' found at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            return;
          } else {
            uniqueLocationIds.add(id);
          }

          if (siteName === '' || siteName === null || siteName === undefined) {
            this.toast.show({ message: `Site name is blank at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            return;
          }

          if (siteCode === '' || siteCode === null || siteCode === undefined) {
            this.toast.show({ message: `Site Code is blank at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            return;
          }
          // else if (LocationNames.has(siteName)) {
          //   this.toast.show({ message: `Duplicate Site Name "${siteName}" found at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
          //   return;
          // } else {
          //   LocationNames.add(siteName);
          // }
          if (sitegatename === '' || sitegatename === null || sitegatename === undefined) {
            this.toast.show({ message: `Site gate name is blank at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            return;
          }
          rowData['SiteName'] = siteName;
          rowData['SiteCode'] = siteCode;
          rowData['SiteGateName'] = sitegatename
          rowData['IsAltitudeApplicable'] = isaltitudeapplicable.toLowerCase() == 'yes' ? true : false;
          rowData['AltitudeRadius'] = altituderadius;
          rowData['IsMocked'] = true;
          this.MultiGeoRecord.push(rowData);
          console.log(this.MultiGeoRecord)
        }
        this.BulkInsertUpdate(this.MultiGeoRecord);
      } else {
        console.error('Failed to read the file.');
      }
    };
    reader.readAsBinaryString(file);
  }
  BulkInsertUpdate(Data: any) {
    this.User = this.sessionService.GetUserDetails();
    if (this.MultiGeoRecord.length === 0) {
      this.toast.show({ message: 'No Data Avaliable!', type: toastTypeEnum.warning });
      return
    }
    const shiftgroupData = {
      SelectType: 'UPLOAD',
      ESS_SiteGateGeoMappingInsert: Data,
      UserId: this.User.UserId,
    };
    this.isDisabled = true;
    this.multipleGeoMapService.ESS_SiteGateGeoMapping_BlukInsert(shiftgroupData).subscribe(
      data => {
        if (data.Error_Code == '01') {
          this.toast.show({ message: data.Error_Message, type: toastTypeEnum.success });
        }
        else {
          this.toast.show({ message: data.Error_Message, type: toastTypeEnum.danger });
        }
        this.isDisabled = false;
        //this.GetData();
      },
      error => {
        console.error('Error:', error);
        this.isDisabled = false;
      });
  }
  downloadExcel() {
    this.download.downloadExcel('MultipleLocationGeoMapping');
  }
}


